module.exports = __webpack_public_path__ + "assets/83d1c691b58768e3ec0a1f88450a7ceb.js";